/**
 * App configuration — the config-driven source of truth for the sidebar nav.
 *
 * `APP_CONFIG.navigation` lists the sidebar items in display order. AppNav maps
 * over this list, resolving each `icon` string against its local regular/filled
 * icon map and gating visibility by `requires`:
 *   - no `requires`   → always visible
 *   - `requires: 'reviewer'` → visible to reviewers and admins
 *   - `requires: 'admin'`    → visible to admins only
 *
 * External's role model is reviewer/admin only (see useCurrentUser).
 */

export interface NavItemConfig {
  /** Stable identity + NavItem value (also used as the selected-state key). */
  key: string;
  /** Visible label. */
  label: string;
  /** Route path (also the NavItem href). */
  path: string;
  /** Icon key resolved by AppNav's regular/filled icon map. */
  icon: string;
  /** Role gate; omit for always-visible. */
  requires?: 'reviewer' | 'admin';
}

export const APP_CONFIG = {
  navigation: [
    { key: 'dashboard', label: 'Dashboard', path: '/dashboard', icon: 'dashboard' },
    { key: 'submissions', label: 'Submissions', path: '/submissions', icon: 'submissions' },
    { key: 'intake-form', label: 'Intake Form', path: '/intake-form', icon: 'intakeForm', requires: 'reviewer' },
    { key: 'admin', label: 'Admin', path: '/admin', icon: 'admin', requires: 'admin' },
  ] as NavItemConfig[],
};

export default APP_CONFIG;
